import API_BASE_URL from '../config/api';

/**
 * Returns an error message if (pdfClientName, jobType) is reserved; otherwise null.
 */
export async function getReservedPdfClientError(
  pdfClientName: string,
  jobType: string
): Promise<string | null> {
  const name = (pdfClientName || '').trim().toLowerCase();
  const jt = (jobType || '').trim().toLowerCase();
  if (!name || (jt !== 'exp' && jt !== 'imp')) {
    return null;
  }

  try {
    const resp = await fetch(
      `${API_BASE_URL}/reserved-pdf-clients?job_type=${encodeURIComponent(jt)}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      }
    );
    const data = await resp.json();
    if (!resp.ok || !data.success || !Array.isArray(data.items)) {
      return null;
    }
    const reserved = data.items.some(
      (item: { pdf_client_name?: string }) =>
        String(item.pdf_client_name || '').trim().toLowerCase() === name
    );
    if (reserved) {
      return `'${pdfClientName.trim()}' is reserved for a hardcoded ${jt.toUpperCase()} format. Please choose a different PDF client name.`;
    }
  } catch {
    // Backend save-parser will still enforce; don't block UX on list fetch failure
  }
  return null;
}

/** Parse "clientname_jobtype" into parts (last underscore separates job type). */
export function parseClientJobFromParserName(parserName: string): {
  pdfClientName: string;
  jobType: string;
} {
  const raw = (parserName || '').trim();
  const base = raw.toLowerCase().endsWith('.json') ? raw.slice(0, -5) : raw;
  const idx = base.lastIndexOf('_');
  if (idx <= 0 || idx === base.length - 1) {
    return { pdfClientName: base, jobType: '' };
  }
  return {
    pdfClientName: base.slice(0, idx),
    jobType: base.slice(idx + 1),
  };
}
